import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { StoreProvider } from "./context/StoreContext";
import { AuthProvider } from "./context/AuthContext";
import { Header } from "./components/Header";
import { CartDrawer } from "./components/CartDrawer";
import { Footer } from "./components/Footer";
import { CookieBanner } from "./components/CookieBanner";
import { SiteGate } from "./components/SiteGate";
import Home from "./pages/Home";
import ProductPage from "./pages/ProductPage";
import AccountPage from "./pages/AccountPage";
import ResetPassword from "./pages/ResetPassword";
import LaunchPage from "./pages/LaunchPage";
import NotFound from "./pages/NotFound";
import AuthCallback from "./pages/AuthCallback";
import { useStore } from "./context/StoreContext";

// Google sign-in return: the session_id fragment must be handled synchronously during render (useLocation().hash)
const AppRoutes = ({ children }) => { const location = useLocation(); return location.hash?.includes("session_id=") ? <AuthCallback /> : children; };
const HomeOrLaunch = () => { const { config } = useStore(); return config.site_mode === "launch" ? <LaunchPage /> : <Home />; };
import AdminPage from "./pages/AdminPage";
import InfoPage from "./pages/InfoPage";
import CmsPage from "./pages/CmsPage";
import CheckoutPage from "./pages/CheckoutPage";
import { ChatWidget } from "./components/ChatWidget";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (a) {
        e.preventDefault();
        const el = document.querySelector(a.getAttribute("href"));
        if (el) lenis.scrollTo(el, { offset: -70 });
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      lenis.destroy();
      document.removeEventListener("click", onAnchor);
    };
  }, []);

  return (
    <BrowserRouter>
      <StoreProvider>
      <AuthProvider>
        <ScrollToTop />
        <SiteGate>
        <div className="bg-[#FAF7F2] min-h-screen antialiased">
          <Header />
          <main>
            <AppRoutes>
            <Routes>
              <Route path="/" element={<HomeOrLaunch />} />
              <Route path="/boutique" element={<Home />} />
              <Route path="/produit/:id" element={<ProductPage />} />
              <Route path="/compte" element={<AccountPage />} />
              <Route path="/reinitialiser" element={<ResetPassword />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/informations" element={<InfoPage />} />
              <Route path="/p/:slug" element={<CmsPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            </AppRoutes>
          </main>
          <Footer />
          <CartDrawer />
          <ChatWidget />
          <CookieBanner />
          <Toaster position="bottom-right" richColors toastOptions={{ style: { fontFamily: "'Outfit', sans-serif" } }} />
        </div>
        </SiteGate>
      </AuthProvider>
      </StoreProvider>
    </BrowserRouter>
  );
}

export default App;
